import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { db } from "../../firebase";
import { query, collection, getDocs, orderBy } from "firebase/firestore";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import { Refresh } from "@mui/icons-material";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import { Divider } from "@mui/material";
import PoMainForm from "../po/PoMainForm";

const styleMove = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 560,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const PoMain = () => {
  const [data, setData] = useState([]);

  // const [openBank, setOpenBank] = useState(false);
  const [updateBank, setUpdateBank] = useState(false);

  const handleClose = () => {
    // setOpenBank(false);
    setUpdateBank(false);
  };
  // const [pettyCash, setPettyCash] = useState(0);
  const [loading, setLoading] = useState(true);
  const [location, setLocation] = useState("");
  const [id, SetId] = useState("");
  const [date, setDate] = useState("");

  const [user, setUser] = useState("");
  const [cash, setCash] = useState(0);
  const [cashApp, setCashApp] = useState(0);
  const [zelle, setZelle] = useState(0);
  const [card, setCard] = useState(0);
  const [other, setOther] = useState(0);
  const [expense, setExpense] = useState(0);
  const [description, setDescription] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const ref = collection(db, "po");
      const q = query(ref, orderBy("date", "desc"));

      const data = await getDocs(q);
      setData(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
      setLoading(false);
    };

    fetchData();
  }, []);

  const ModalFunc = (params) => {
    SetId(params[0]);

    setUpdateBank(true);
  };

  // const handleModalAdd = () => {
  //   setLocation("store");
  //   setCash(0);
  //   setCashApp(0);
  //   setZelle(0);
  //   setCard(0);
  //   setOther(0);
  //   setExpense(0);
  //   setDescription("");
  //   setOpenBank(true);
  // };

  const handleRefresh = () => {
    window.location.reload();
  };

  const columns = [
    {
      name: "id", // 0
      label: "id",
      options: {
        display: false,
      },
    },
    {
      name: "date", // 1
      label: "Date",
    },
    {
      name: "title", // 2
      label: "title",
    },
    {
      name: "quantity", // 3
      label: "quantity",
    },
    {
      name: "cost", // 4
      label: "cost",
    },
    {
      name: "vendorName", // 5
      label: "vendor",
    },
    {
      name: "shipping", // 6
      label: "shipping",
    },
    {
      name: "itemId", // 7
      label: "itemId",
      options: {
        display: false,
      },
    },

    // Add more columns as needed
  ];
  const AddButton = () => (
    <>
      <Tooltip disableFocusListener title="Refresh DATA">
        <IconButton onClick={handleRefresh}>
          <Refresh />
        </IconButton>
      </Tooltip>
    </>
  );
  const options = {
    customToolbar: AddButton,
    selectableRowsHideCheckboxes: true,
    onRowClick: (rowData) => {
      ModalFunc(rowData);
    },
    sortOrder: {
      name: "title",
      direction: "asc",
    },
  };

  return (
    <>
      {/* =====  UPDATE ============ */}
      <Modal keepMounted open={updateBank} onClose={handleClose}>
        <Box sx={styleMove}>
          <Divider />
          <PoMainForm
            setId={SetId}
            id={id}
            cash={cash}
            setCash={setCash}
            cashApp={cashApp}
            setCashApp={setCashApp}
            zelle={zelle}
            setZelle={setZelle}
            card={card}
            setCard={setCard}
            other={other}
            setOther={setOther}
            expense={expense}
            setExpense={setExpense}
            description={description}
            setDescription={setDescription}
            location={location}
            setLocation={setLocation}
            user={user}
            setUser={setUser}
            date={date}
            setDate={setDate}
            // setOpenBank={setOpenBank}
            operation="update"
            textButton="UPDATE RECORD"
          />
        </Box>
      </Modal>

      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "45vh",
            borderRadius: 20,
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <MUIDataTable
          title="Purchase Order Detail"
          columns={columns}
          options={options}
          data={data}
          checkboxSelection
        />
      )}
    </>
  );
};
export default PoMain;
